import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titlebar-title --mobile" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "titlebar-text" }, "Reservas")
  ])
], -1)
const _hoisted_4 = { class: "titlebar-actions" }
const _hoisted_5 = {
  class: "titlebar-actions-secondary",
  style: {"display":"flex","gap":"10px"}
}
const _hoisted_6 = { class: "ui-button-content" }
const _hoisted_7 = { class: "ui-button-content" }
const _hoisted_8 = { class: "ui-button-content" }
const _hoisted_9 = { class: "ui-button-content" }
const _hoisted_10 = { class: "titlebar-actions-primary" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Nova Reserva")
], -1)
const _hoisted_12 = { class: "ui-card" }
const _hoisted_13 = { class: "ui-card-body" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-16"
}
const _hoisted_19 = { class: "ant-row ui-mb-20" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-input-affix-wrapper" }
const _hoisted_22 = { class: "ant-input-prefix" }
const _hoisted_23 = {
  role: "img",
  "aria-label": "user",
  type: "user",
  class: "anticon anticon-user"
}
const _hoisted_24 = { class: "ui-table" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell" }, " Reserva "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell" }, " Box "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell" }, " Data Check-In "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell" }, " Data Check-Out "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-7 ui-cell" }, " Cliente "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell" }, " Status "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_26 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_27 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-ellipsis",
  "data-title": "Nome"
}
const _hoisted_28 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-2 ui-cell ui-ellipsis",
  "data-title": "Box"
}
const _hoisted_29 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-ellipsis",
  "data-title": "Data Check-In"
}
const _hoisted_30 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-ellipsis",
  "data-title": "Data Check-Out"
}
const _hoisted_31 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-7 ui-cell ui-ellipsis",
  "data-title": "Cliente"
}
const _hoisted_32 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-ellipsis",
  "data-title": "Status"
}
const _hoisted_33 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center",
  "data-title": "Ações"
}
const _hoisted_34 = { class: "ui-actions" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, " Aplicar ", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, null, -1)
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_combo_area = _resolveComponent("combo-area")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_combo_area_box = _resolveComponent("combo-area-box")!
  const _component_selecionar_periodo = _resolveComponent("selecionar-periodo")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_combo_status_reserva = _resolveComponent("combo-status-reserva")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_reserva_mapa_modal = _resolveComponent("reserva-mapa-modal")!
  const _component_reserva_disponibilidade_box_modal = _resolveComponent("reserva-disponibilidade-box-modal")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_affix, { "offset-top": 50 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_tooltip, {
                placement: "top",
                title: "Visualizar Mapa"
              }, {
                default: _withCtx(() => [
                  ((_ctx.state.parametrosConsulta.codigoArea > 0))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "ui-button",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarMapaReservas = true))
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_icone, { nome: "visualizar" })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tooltip, {
                placement: "top",
                title: "Disponibilidade dos Boxes"
              }, {
                default: _withCtx(() => [
                  ((_ctx.state.parametrosConsulta.codigoArea > 0))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "ui-button",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.apresentarDisponibilidadeBoxes = true))
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_icone, { nome: "agenda" })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              ((_ctx.UtilitarioGeral.validaLista(_ctx.state.reservas)))
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 0,
                    placement: "top",
                    title: "Imprimir - Resumo Diário"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "ui-button",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gerarRelatorioResumoDiario()))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_icone, { nome: "imprimir" })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.UtilitarioGeral.validaLista(_ctx.state.reservas)))
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 1,
                    placement: "top",
                    title: "Imprimir - Listagem de Reservas"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "ui-button",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gerarRelatorioListagem()))
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_icone, { nome: "checklist" })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                class: "ui-button -primary",
                to: { name: 'ReservaCadastroCriar' }
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_form_item, { label: "Área" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_combo_area, {
                      codigo: _ctx.state.parametrosConsulta.codigoArea,
                      "onUpdate:codigo": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.parametrosConsulta.codigoArea) = $event)),
                      placeholder: 'Selecione uma Área',
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.buscarDados()))
                    }, null, 8, ["codigo"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_a_form_item, { label: "Box" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_combo_area_box, {
                      key: 'AREA' + _ctx.state.parametrosConsulta.codigoArea + 'BOX' + _ctx.state.parametrosConsulta.codigoBox,
                      codigoArea: _ctx.state.parametrosConsulta.codigoArea,
                      codigo: _ctx.state.parametrosConsulta.codigoBox,
                      "onUpdate:codigo": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.parametrosConsulta.codigoBox) = $event)),
                      disabled: (_ctx.state.parametrosConsulta.codigoArea === 0),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buscarDados()))
                    }, null, 8, ["codigoArea", "codigo", "disabled"]))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.state.parametrosConsulta.periodo ===7 ?'ant-col ant-col-xs-24 ant-col-xl-10':'ant-col ant-col-xs-24 ant-col-xl-10')
              }, [
                _createVNode(_component_a_form_item, { label: "Período" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.state.parametrosConsulta.periodo ===7 ?'ant-col ant-col-xs-24 ant-col-xl-8':'ant-col ant-col-xs-24 ant-col-xl-24')
                      }, [
                        _createVNode(_component_selecionar_periodo, {
                          valor: _ctx.state.parametrosConsulta.periodo,
                          "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.parametrosConsulta.periodo) = $event)),
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.buscarDados()))
                        }, null, 8, ["valor"])
                      ], 2),
                      ((_ctx.state.parametrosConsulta.periodo ===7))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_selecionar_data_inicial_final, {
                              dataInicialSelecionada: _ctx.state.parametrosConsulta.dataInicial,
                              "onUpdate:dataInicialSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.parametrosConsulta.dataInicial) = $event)),
                              dataFinalSelecionada: _ctx.state.parametrosConsulta.dataFinal,
                              "onUpdate:dataFinalSelecionada": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.parametrosConsulta.dataFinal) = $event)),
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.buscarDados()))
                            }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.state.parametrosConsulta.periodo ===7 ?'ant-col ant-col-xs-24 ant-col-xl-4':'ant-col ant-col-xs-24 ant-col-xl-4')
              }, [
                _createVNode(_component_a_form_item, { label: "Status" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_combo_status_reserva, {
                      valor: _ctx.state.parametrosConsulta.status,
                      "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.parametrosConsulta.status) = $event)),
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.buscarDados()))
                    }, null, 8, ["valor"])
                  ]),
                  _: 1
                })
              ], 2)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_a_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_icone, { nome: "pesquisar" })
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Você pode Buscar por Nome,CPF,CNPJ e Telefone do cliente, Box ...",
                    type: "text",
                    class: "ant-input ui-full",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.parametrosConsulta.valorPesquisa) = $event)),
                    onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.buscarReservaPorNome()))
                  }, null, 544), [
                    [_vModelText, _ctx.state.parametrosConsulta.valorPesquisa]
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            ((_ctx.state.reservas.length > 0))
              ? (_openBlock(), _createBlock(_component_a_form, {
                  key: 0,
                  layout: "vertical"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.reservas, (reserva) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: reserva.codigo,
                            class: "ant-row ui-row"
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_router_link, {
                                class: "ui-link",
                                to: { name: 'ReservaCadastroEditar', params: { codigo:reserva.codigo }}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(reserva.numeroIdentificacao), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(reserva.identificacaoBox), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(reserva.dataCheckIn)), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(reserva.dataCheckOut)), 1),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_a_tooltip, {
                                title: 'CPF:' + reserva.cpfCnpjCliente
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(reserva.nomeCliente), 1)
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.obterDescricaoStatus(reserva.status)), 1),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createVNode(_component_a_tooltip, { title: "Editar Reserva" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, {
                                      class: "ui-action",
                                      to: { name: 'ReservaCadastroEditar', params: { codigo:reserva.codigo }}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_tooltip, { title: "Deletar Reserva" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", {
                                      class: "ui-action",
                                      onClick: ($event: any) => (_ctx.confirmaExclusao(reserva))
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_35)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_a_pagination, {
                          class: "ui-pagination",
                          current: _ctx.appBase.paginacao.paginaAtual,
                          "onUpdate:current": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.appBase.paginacao.paginaAtual) = $event)),
                          size: "small",
                          total: _ctx.appBase.paginacao.totalRegistros,
                          "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} Reservas`,
                          "page-size": _ctx.appBase.paginacao.qtdeRegistrosPagina,
                          "show-size-changer": "",
                          onShowSizeChange: _ctx.qtdeRegistrosPaginaAlterada,
                          onChange: _ctx.paginacaAlterada
                        }, null, 8, ["current", "total", "show-total", "page-size", "onShowSizeChange", "onChange"])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_result, {
                  key: 1,
                  status: "404",
                  title: "Crie uma nova reserva",
                  "sub-title": "Ou preencha os filtros para pesquisar."
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(_component_a_drawer, {
      visible: _ctx.state.apresentarFiltros,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.apresentarFiltros) = $event)),
      class: "custom-class",
      style: {"color":"red"},
      title: "Filtros",
      placement: "right"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              class: "ui-button -primary ui-full",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.buscarDados()))
            }, _hoisted_41)
          ]),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              class: "ui-button -second ui-full",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.limparFiltros()))
            }, " Limpar filtros ")
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_collapse, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "Status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  class: "ui-inline-grid",
                  value: _ctx.state.parametrosConsulta.status,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.parametrosConsulta.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pendente")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reservada")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelada")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: undefined }, {
                      default: _withCtx(() => [
                        _createTextVNode("Todas")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_reserva_mapa_modal, {
      visivel: _ctx.state.apresentarMapaReservas,
      "onUpdate:visivel": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.apresentarMapaReservas) = $event)),
      codigoArea: _ctx.state.parametrosConsulta.codigoArea,
      periodo: _ctx.state.parametrosConsulta.periodo,
      dataInicial: _ctx.state.parametrosConsulta.dataInicial,
      dataFinal: _ctx.state.parametrosConsulta.dataFinal
    }, null, 8, ["visivel", "codigoArea", "periodo", "dataInicial", "dataFinal"]),
    _createVNode(_component_reserva_disponibilidade_box_modal, {
      visivel: _ctx.state.apresentarDisponibilidadeBoxes,
      "onUpdate:visivel": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.apresentarDisponibilidadeBoxes) = $event)),
      codigoArea: _ctx.state.parametrosConsulta.codigoArea,
      periodo: _ctx.state.parametrosConsulta.periodo,
      dataInicial: _ctx.state.parametrosConsulta.dataInicial,
      dataFinal: _ctx.state.parametrosConsulta.dataFinal
    }, null, 8, ["visivel", "codigoArea", "periodo", "dataInicial", "dataFinal"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}